import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'
import { useState, forwardRef, useCallback } from 'react'
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack'
import { Button, Card, CardActions, Paper, Collapse, Typography, IconButton } from '@mui/material'

import CloseModalIcon from '../../assets/icons/close-modal-icon.svg'
import CheckIconGreen from '../../assets/icons/check-icon-green.svg'
import ExpandMoreGreenIcon from '../../assets/icons/expand-more-green-icon.svg'

const useStyles = makeStyles(() => ({
  root: {
    '@media (min-width:600px)': {
      minWidth: '344px !important'
    }
  },
  card: {
    width: '100%'
  },
  typography: {
    color: '#107569'
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
    justifyContent: 'space-between'
  },
  icons: {
    marginLeft: 'auto'
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    color: '#107569',
    transition: 'all .2s'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  paper: {
    backgroundColor: '#fff',
    padding: 16
  },
  button: {
    padding: 0,
    textTransform: 'none'
  }
}))

interface ReportCompleteProps extends CustomContentProps {
  reportType?: string
  downloadLink?: string
  allowDownload?: boolean
}

const ReportComplete = forwardRef<HTMLDivElement, ReportCompleteProps>(({ id, ...props }, ref) => {
  const classes = useStyles()
  const { closeSnackbar } = useSnackbar()
  const { t } = useTranslation(['common'])
  const [expanded, setExpanded] = useState(false)

  const handleExpandClick = useCallback(() => {
    setExpanded((oldExpanded) => !oldExpanded)
  }, [])

  const handleDismiss = useCallback(() => {
    closeSnackbar(id)
  }, [id, closeSnackbar])

  return (
    <SnackbarContent
      ref={ref}
      className={classes.root}
    >
      <Card
        className={classes.card}
        style={{ backgroundColor: '#D1F1EC' }}
      >
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography
            variant="body2"
            className={classes.typography}
          >
            {props.message}
          </Typography>
          <div className={classes.icons}>
            <IconButton
              aria-label="Show more"
              size="small"
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded
              })}
              onClick={handleExpandClick}
            >
              <img
                src={ExpandMoreGreenIcon}
                style={{ width: '24px' }}
                alt="expand-more-green-icon"
              />
            </IconButton>
            <IconButton
              size="small"
              className={classes.expand}
              onClick={handleDismiss}
            >
              <img
                src={CloseModalIcon}
                alt="close-modal-icon"
                style={{ width: '24px' }}
              />
            </IconButton>
          </div>
        </CardActions>
        <Collapse
          in={expanded}
          timeout="auto"
          unmountOnExit
        >
          <Paper className={classes.paper}>
            <Typography
              gutterBottom
              variant="caption"
              style={{ color: '#000', display: 'block' }}
            >
              {props.reportType === 'csv' ? t('notifications.csvReady') : t('notifications.pdfReady')}
            </Typography>
            <Button
              size="small"
              color="primary"
              className={classes.button}
              onClick={() => {
                window.open(props.downloadLink, '_blank')
              }}
            >
              <img
                src={CheckIconGreen}
                style={{ width: '24px' }}
                alt="chack-icon-green-icon"
              />
              {t('notifications.downloadNow')}
            </Button>
          </Paper>
        </Collapse>
      </Card>
    </SnackbarContent>
  )
})

ReportComplete.displayName = 'ReportComplete'

export default ReportComplete
